// Module-level toast event bus.
// Kept in a plain .js file so Toast.jsx can stay component-only (React Fast Refresh).

let counter = 0;
const listeners = new Set();
const state = { items: [] };

function emit() {
    listeners.forEach(fn => fn(state.items));
}

function push(message, type = 'info', duration = 3000) {
    const id = ++counter;
    state.items = [...state.items, { id, message, type }];
    emit();
    if (duration > 0) {
        setTimeout(() => dismiss(id), duration);
    }
    return id;
}

export function dismiss(id) {
    state.items = state.items.filter(t => t.id !== id);
    emit();
}

export function subscribe(fn) {
    listeners.add(fn);
    return () => { listeners.delete(fn); };
}

export function getItems() {
    return state.items;
}

export const toast = {
    success: (msg, dur) => push(msg, 'success', dur),
    error: (msg, dur) => push(msg, 'error', dur ?? 4500),
    info: (msg, dur) => push(msg, 'info', dur),
    warning: (msg, dur) => push(msg, 'warning', dur ?? 7000),
    dismiss,
};
